import {merge, BehaviorSubject} from 'rxjs';
import {map, scan} from 'rxjs/operators';
import {fixationBook$} from './book';
import {market$} from './market-contract';

export const context$ = new BehaviorSubject({});

merge(market$.pipe(map(convertMarketData)), fixationBook$.pipe(map(convertBookData)))
  .pipe(scan((p, action) => action(p), {}))
  .subscribe((context) => context$.next(context));

function convertMarketData(market: ContractMarket) {
  return function (old) {
    const {closeEp: last_price, markPriceEp: mark_price} = market;
    return {...old, last_price, mark_price};
  };
}

function convertBookData(book: Book) {
  return function (old) {
    const {bid1Ep: bid1, ask1Ep: ask1} = book;
    return {...old, bid1, ask1};
  };
}
